import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AppStateT } from "../store"

type StateT = {
    selected: string[]
}

const initialState: StateT = {
    selected: [],
}

type PayloadT = {
    id: string
}

export const activeAnimationSlice = createSlice({
    name: "activeAnimation",
    initialState,
    reducers: {
        setActiveAnimationAction: (state, action: PayloadAction<PayloadT>) => {
            state.selected = [action.payload.id]
        },
        setSelectedAnimationsForObjectAction: (
            state,
            action: PayloadAction<{ animationsIds: string[] }>
        ) => {
            state.selected = action.payload.animationsIds
        },
        addSelectedAnimationsAction: (state, action: PayloadAction<string[]>) => {
            const set = new Set([...state.selected, ...action.payload])
            state.selected = Array.from(set)
        },
        removeSelectedAnimationsAction: (state, action: PayloadAction<string[]>) => {
            state.selected = state.selected.filter((id) => !action.payload.includes(id))
        },
        clearSelectedAnimationsAction: (state) => {
            state.selected = []
        },
    },
})

/**
 * Booleans and counts instead of the selection array.
 *
 * `TimelineTween` is mounted once per animation — several hundred times — and used to
 * subscribe to `state.activeAnimation.selected` itself. Since that array is replaced on every
 * selection change, clicking a single tween (or an object, which also selects its animations)
 * re-rendered every tween in the timeline. A boolean only changes for the tweens whose state
 * really flipped.
 */
export const selectIsAnimationSelected = (state: AppStateT, animationId: string): boolean =>
    state.activeAnimation.selected.includes(animationId)

export const selectSelectedAnimationCount = (state: AppStateT): number =>
    state.activeAnimation.selected.length

export const {
    setActiveAnimationAction,
    setSelectedAnimationsForObjectAction,
    addSelectedAnimationsAction,
    removeSelectedAnimationsAction,
    clearSelectedAnimationsAction,
} = activeAnimationSlice.actions

export default activeAnimationSlice.reducer
